import type { AnalyticsExceptionProperties } from "@repo/analytics/client";

const reportedDigests = new Set<string>();

const NOISY_CLIENT_ERROR_PATTERNS = [
  "Minified React error #185",
  "Minified React error #418",
  "Server Components render",
  "signal is aborted",
];

export function reportClientError(
  error: Error & { digest?: string },
  properties?: AnalyticsExceptionProperties,
) {
  if (typeof window === "undefined") return;

  if (
    !/^\/(?:seller|buyer)-onboarding\//.test(window.location.pathname) &&
    NOISY_CLIENT_ERROR_PATTERNS.some((pattern) =>
      error.message.includes(pattern),
    )
  ) {
    return;
  }

  console.error("[Venturu] Client error:", error);

  const key = error.digest ?? error.message;
  if (reportedDigests.has(key)) return;
  reportedDigests.add(key);

  import("@repo/analytics/client")
    .then(({ analytics }) => {
      analytics.trackError(error, undefined, properties);
    })
    .catch(() => {
      // Analytics module failed to load
    });
}
